// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-content {
  overflow: hidden;
}
.mat-dialog-content-step-1 {
  height: 85vh;
}
.locationContainer {
  max-height: 100%;
  height: 100%;
}
.listContainer {
  max-height: 100%;
  overflow: auto;
  border: solid 1px #ccc;
  min-height: 60px;
  background: white;
  border-radius: 4px;
}
.destinationContainer {
  background-color: #e2e7e2;
}
.location-box {
  padding: 20px 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  cursor: move;
  background: white;
  font-size: 14px;
}
location-box:last-child {
  border: none;
}
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.listContainer.cdk-drop-list-dragging .listContainer:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.cdk-overlay-connected-position-bounding-box,
.cdk-global-overlay-wrapper,
.cdk-overlay-container {
  z-index: 99999 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/decision-grid/Components/dialogs/group-setup/group-setup.component.less"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AAIA;EACE,YAAA;AAFF;AAKA;EACE,gBAAA;EACA,YAAA;AAHF;AAMA;EACE,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAJF;AAOA;EACE,yBAAA;AALF;AAQA;EACE,kBAAA;EACA,6BAAA;EACA,0BAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AANF;AASA;EACE,YAAA;AAPF;AAaA;EACE,sBAAA;EACA,kBAAA;EACA,qHAAA;AAXF;AAoBA;EACE,sDAAA;AAlBF;AAqBA;EACE,sDAAA;AAnBF;AAsBA;;;EAGA,yBAAA;AApBA","sourcesContent":["// app-group-setup {\n\n.mat-dialog-content {\n  overflow: hidden;\n}\n\n.mat-dialog-content-step-1 {\n  height: 85vh;\n}\n\n.locationContainer {\n  max-height: 100%;\n  height: 100%;\n}\n\n.listContainer {\n  max-height: 100%;\n  overflow: auto;\n  border: solid 1px #ccc;\n  min-height: 60px;\n  background: white;\n  border-radius: 4px;\n}\n\n.destinationContainer {\n  background-color: #e2e7e2;\n}\n\n.location-box {\n  padding: 20px 10px;\n  border-bottom: solid 1px #ccc;\n  color: rgba(0, 0, 0, 0.87);\n  cursor: move;\n  background: white;\n  font-size: 14px;\n}\n\nlocation-box:last-child {\n  border: none;\n}\n\n\n// }\n\n.cdk-drag-preview {\n  box-sizing: border-box;\n  border-radius: 4px;\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n  0 8px 10px 1px rgba(0, 0, 0, 0.14),\n  0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.cdk-drag-placeholder {\n  //opacity: 0;\n}\n\n.cdk-drag-animating {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.listContainer.cdk-drop-list-dragging .listContainer:not(.cdk-drag-placeholder) {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.cdk-overlay-connected-position-bounding-box,\n.cdk-global-overlay-wrapper,\n.cdk-overlay-container{\nz-index: 99999 !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
